import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';  // ⭐ import 확인
import store from './store';  // ⭐ import 확인
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>  {/* ⭐ Provider로 감싸기 */}
            <App />
        </Provider>
    </React.StrictMode>
);